const secrets = {
    YOUR_SERVICE_ID: "service_jebd2ve",
    YOUR_TEMPLATE_ID: "template_qhyb5ok",
    YOUR_USER_ID: "oi5CzJc4UF2_WaaV2",
};

export default secrets;
